import React from 'react'

const SearchIcon3D = ({
  color = '#fff',
  imgStyle = { width: '42px', height: '42px' },
  imgClass = '',
  imgClick = () => {},
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...imgStyle }}
      viewBox="0 0 16.755 16.884"
      className={`${imgClass}`}
      onClick={imgClick}
    >
      <g id="search-5-svgrepo-com" transform="translate(-4.745 -4.115)">
        <path
          id="Path_918"
          data-name="Path 918"
          d="M7.458,16.621a6.848,6.848,0,0,1-1.83-3.486A6.924,6.924,0,0,1,6.009,9.2,6.783,6.783,0,0,1,8.471,6.147a6.585,6.585,0,0,1,7.428,0A6.782,6.782,0,0,1,18.362,9.2a6.923,6.923,0,0,1,.381,3.932,6.847,6.847,0,0,1-1.83,3.486,6.6,6.6,0,0,1-9.454,0Z"
          transform="translate(0)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          fillRule="evenodd"
        />
        <path
          id="Path_919"
          data-name="Path 919"
          d="M11.727,7.2A.814.814,0,1,0,11.9,8.822Zm2.008,2.7a.814.814,0,1,0,1.5-.634Zm3.385,5.852a.814.814,0,0,0-1.149,1.152Zm2.526,4.82A.814.814,0,1,0,20.8,19.425ZM11.9,8.822A1.79,1.79,0,0,1,13.735,9.9l1.5-.634A3.417,3.417,0,0,0,11.727,7.2Zm4.072,8.085,3.675,3.669L20.8,19.425,17.12,15.756Z"
          transform="translate(0.466 0.185)"
          fill={color}
        />
      </g>
    </svg>
  )
}

export default SearchIcon3D
